import { render } from "./UseSale.vue?vue&type=template&id=36a44b37&scoped=true"
import script from "./UseSale.vue?vue&type=script&lang=js"
export * from "./UseSale.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=36a44b37&scoped=true&lang=css&external"
import "./UseSale.vue?vue&type=style&index=1&id=36a44b37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a44b37"]])

export default __exports__